import React, { useEffect, useState } from 'react';
import { Alert, Col, Divider, Row } from 'antd';
import { useAtomValue, useAtom } from 'jotai';
import { fullSensitivityConfigAtom, selectedProductAtom } from '../../atoms';
import { StyledInput, StyledUnit, StyledConfigLabel, StyledInputWrapper } from './styled';
import { getMetricDisplayName } from '@src/utils/metrics';
import { useSelector } from 'react-redux';
import { aiAlerts1minPersistenceSelector } from '@src/store/common/selectors';
import { checkErrors } from '../../popup/errorUtils';
import { adAiAlertUnits } from '@src/utils/aiAlerts/metrics';

const AdSensitivityRows = ({ sensitivity }) => {
  // const selectedProduct = useAtomValue(selectedProductAtom);
  const [sensitivityDetails, setSensitivityDetails] = useAtom(fullSensitivityConfigAtom);
  const [errorMsg, setErrorMsg] = useState('');
  const is1minEnabled = useSelector(aiAlerts1minPersistenceSelector);
  // const minVal = is1minEnabled ? 1 : 3;

  const style: React.CSSProperties = {
    padding: '0 0 15px 0',
    fontWeight: 500,
    fontSize: 14,
    display: 'flex',
  };

  const onChangeKey =
    ({ key }) =>
    (value) => {
      setSensitivityDetails((prev) => {
        return prev.map((sensitivityConfig) => {
          if (sensitivityConfig.metric === sensitivity.metric) {
            return { ...sensitivityConfig, [key]: value };
          }
          return sensitivityConfig;
        });
      });
    };

  useEffect(() => {
    setErrorMsg(checkErrors(sensitivityDetails.find((m) => m.metric === sensitivity.metric)));
  }, [sensitivityDetails]);

  const metricName = getMetricDisplayName({
    metricKey: sensitivity.metricKey,
    context: 'EI',
  });

  return (
    <>
      <Divider orientation="left" orientationMargin="0" style={{ margin: '10px 0' }}>
        {metricName}
      </Divider>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={12}>
          <StyledConfigLabel style={style}>Threshold exceeds</StyledConfigLabel>
        </Col>

        <Col className="gutter-row" span={12}>
          <div style={style}>
            <StyledInput
              min={1}
              max={100}
              onChange={onChangeKey({ key: 'asf' })}
              value={sensitivity.asf}
            />
            <StyledUnit>{adAiAlertUnits[sensitivity.metric]}</StyledUnit>
          </div>
        </Col>
      </Row>

      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={12}>
          <StyledConfigLabel style={style}>Impacted devices exceeds</StyledConfigLabel>
        </Col>

        <Col className="gutter-row" span={12}>
          <div style={style}>
            <StyledInputWrapper>
              <StyledInput
                min={10}
                max={1000000}
                onChange={onChangeKey({ key: 'impactedUnique' })}
                value={sensitivity.impactedUnique}
              />
              <StyledUnit>#</StyledUnit>
            </StyledInputWrapper>
          </div>
        </Col>
      </Row>
      {errorMsg ? <Alert message={errorMsg} type={'error'} /> : null}
    </>
  );
};

export default React.memo(AdSensitivityRows);
